import { render, staticRenderFns } from "./CarRecommend2.vue?vue&type=template&id=03827144"
import script from "./CarRecommend2.vue?vue&type=script&lang=js"
export * from "./CarRecommend2.vue?vue&type=script&lang=js"
import style0 from "./CarRecommend2.vue?vue&type=style&index=0&id=03827144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports